import React, { useEffect, lazy, Suspense } from 'react';
import { questionsData } from './survey/questionsData';
import steps from './survey/steps';
import * as configs from './survey/configs';
import buildConfig from './survey/buildConfig';
import getParameterFromURL from './utils/scripts/getParameterFromURL';
import { getPageUrlValue, determinePaymentVersion } from './utils/scripts/analyticsTags';
import useResolvedConfig from './hooks/useResolvedConfig';
import useAppLifecycle from './hooks/useAppLifecycle';
import Steps from './pages/steps';
import s from './app.module.scss';
import { useAppStore, useQuestionsStore } from './store';

// Loader показывается только в самом конце воронки — не тянем его в главный бандл.
const Loader = lazy(() => import('./components/loader'));

export default function App() {
  const showSteps = useAppStore((state) => state.showSteps);
  const showLoader = useAppStore((state) => state.showLoader);
  const initialAge = useAppStore((state) => state.initialAge);
  const stepsList = useAppStore((state) => state.list);
  const config = useAppStore((state) => state.config);

  const configToApply = useResolvedConfig(config);
  const onbordingVersion = getParameterFromURL('config') ? getParameterFromURL('config') : '';

  useAppLifecycle();

  useEffect(() => {
    if (stepsList) return;

    useQuestionsStore.getState().setup({
      questionsData,
      predifinedAnswers: undefined,
    });

    const configOptions = {
      config: configToApply,
      configName: config,
      age: initialAge,
      role: undefined,
    };

    steps.setup({
      stepsConfig: buildConfig(configOptions),
      currentStep: configToApply[0].name,
      stepsDetails: (configs as unknown as { stepsDetails: Record<string, Record<string, unknown>> }).stepsDetails,
    });
  }, []);

  useEffect(() => {
    if (!window.loadEvent) {
      const pageUrlValue = getPageUrlValue();
      const paymentVersion = determinePaymentVersion();

      window.loadEvent = true;
      steps.analytics.send({
        event: {
          event: 'onboarding_question',
          quiz_question: 'page_load',
          quiz_answer: pageUrlValue,
          payment_type: paymentVersion,
          link: `${pageUrlValue}${paymentVersion}`,
        },
      });
      localStorage.setItem('link', `${pageUrlValue}${paymentVersion}`);
    }
  }, []);

  return (
    <div className={`${s.app} ${onbordingVersion} application`}>
      {showSteps && !showLoader && <Steps />}
      {showLoader && (
        <Suspense fallback={null}>
          <Loader />
        </Suspense>
      )}
    </div>
  );
}
